'use client'
import Form from "next/form";
import { useActionState, useEffect, useState } from "react";
import { updateSelfUser } from "@/app/api";
import { AtSign, Lock, Smile } from "@/assets/icons";
import { SelfUserResponseType } from "@/types";
import { useRouter } from "next/navigation";
import { CpfMask, CnpjMask, Table, TableRow, TableHeader, TableCell, TextInput, CheckboxInput, ColorButton, ReplyMessage } from "@/components/ui";

interface AllUserUpdateForm {
    user: SelfUserResponseType
}

export function UpdateSelfUserForm({ user }: AllUserUpdateForm) {
    const [showNewPass, setShowNewPass] = useState<boolean>(false)
    const [showConfimNewPass, setShowConfimNewPass] = useState<boolean>(false)
    const [state, formAction, pending] = useActionState(updateSelfUser, {
        values: { name: '', email: '', password: '', confirmPassword: '' },
        errors: {},
        message: '',
    })

    const userIdentifier = user.identifier.length <= 11 ? CpfMask(user.identifier) : CnpjMask(user.identifier)
    const router = useRouter();
    if (state.success?.valueOf() === true) {
        setTimeout(() => {
            router.back();
        }, 1500);
    }

    useEffect(() => {
        if (state.message || state.errors?.password || state.errors?.confirmPassword) {
            setShowNewPass(false);
            setShowConfimNewPass(false);
        }
    }, [state.message, state.errors?.password, state.errors?.confirmPassword]);
    return (
        <div>
            <div className="hidden md:flex">
                <Table>
                    <thead>
                        <TableRow>
                            <TableHeader>Nome</TableHeader>
                            <TableHeader>Email</TableHeader>
                            <TableHeader>CPF/CNPJ</TableHeader>
                            <TableHeader>Data do cadastro</TableHeader>
                        </TableRow>
                    </thead>
                    <tbody>
                        <TableRow>
                            <TableCell>{user.name}</TableCell>
                            <TableCell>{user.email}</TableCell>
                            <TableCell>{userIdentifier}</TableCell>
                            <TableCell>{new Date(user.createdAt).toLocaleDateString()}</TableCell>
                        </TableRow>
                    </tbody>
                </Table>
            </div>

            <div className="flex md:hidden">
                <Table>
                    <thead>
                        <TableRow>
                        </TableRow>
                    </thead>
                    <tbody>
                        <TableRow>
                            <TableHeader>Nome</TableHeader>
                            <TableCell>{user.name}</TableCell>
                            <TableHeader>Email</TableHeader>
                            <TableCell>{user.email}</TableCell>
                            <TableHeader>CPF/CNPJ</TableHeader>
                            <TableCell>{userIdentifier}</TableCell>
                            <TableHeader>Data do cadastro</TableHeader>
                            <TableCell>{new Date(user.createdAt).toLocaleDateString()}</TableCell>
                        </TableRow>
                    </tbody>
                </Table>
            </div>

            <Form action={formAction} className="flex flex-col gap-3">

                {/* name of user */}

                <div className="flex gap-2 items-center">
                    <Smile className="size-4" />
                    <label htmlFor="name">Nome</label>
                </div>
                <TextInput name="name" id="name"
                    required
                    defaultValue={user.name || state?.values?.name}
                    placeholder="Nome" />
                {state?.errors?.name && <p>{state.errors.name}</p>}

                {/* email of user */}

                <div className="flex gap-2 items-center">
                    <AtSign className="size-4" />
                    <label htmlFor="email">Email</label>
                </div>
                <TextInput name="email" id="email"
                    required
                    defaultValue={user.email || state?.values?.email}
                    placeholder="Email" />
                {state?.errors?.email && <p>{state.errors.email}</p>}

                {/* new password of user */}

                <div className="flex gap-2 items-center">
                    <Lock className="size-4" />
                    <div className="flex gap-1 flex-col sm:flex-row sm:items-baseline">
                        <label htmlFor="password">Nova Senha</label>
                        <p className="text-xs">min. 6 caracteres</p>
                    </div>
                </div>
                <TextInput name="password" type={showNewPass ? "text" : "password"} minLength={6} required
                    defaultValue={state?.values?.password}
                    placeholder="Senha" />
                {state?.errors?.password && <p>{state.errors.password}</p>}

                {/* visualizar senha */}

                <div className="flex items-center gap-2 text-sm">
                    <CheckboxInput name="showPassword" id="showPassword" onClick={() => { setShowNewPass(showNewPass ? false : true) }} />
                    Mostrar senha
                </div>

                {/* confirm new password of user */}

                <div className="flex gap-2 items-center">
                    <Lock className="size-4" />
                    <div className="flex gap-1 flex-col sm:flex-row sm:items-baseline">
                        <label htmlFor="confirmPassword">Confirme a Nova Senha</label>
                        <p className="text-xs">min. 6 caracteres</p>
                    </div>
                </div>
                <TextInput name="confirmPassword" type={showConfimNewPass ? "text" : "password"} minLength={6} required
                    defaultValue={state?.values?.confirmPassword}
                    placeholder="Confirme a Nova Senha" />
                {state?.errors?.confirmPassword && <p>{state.errors.confirmPassword}</p>}

                {/* visualizar senha */}

                <div className="flex items-center gap-2 text-sm">
                    <CheckboxInput name="showConfirmPassword" id="showConfirmPassword" onClick={() => { setShowConfimNewPass(showConfimNewPass ? false : true) }} />
                    Mostrar senha
                </div>

                {/* submit */}

                <div className="flex flex-col gap-3 p-4  items-center justify-center">
                    <ColorButton type="submit" disabled={pending}>
                        {pending ? 'Atualizando...' : 'Atualizar'}
                    </ColorButton>
                </div>

            </Form>
            <ReplyMessage message={state?.message || ""} />
        </div>
    )
}